/* eslint-disable */
const loadState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    
    // Custom reviver to handle Date objects
    return JSON.parse(serializedState, (k, v) => {
      if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(v)) {
        return new Date(v);
      }
      return v;
    });
  } catch (err) {
    console.error("Error loading state:", err);
    return undefined;
  }
};

const saveState = (key, state) => {
  try {
    // Custom replacer to handle Date objects
    const serializedState = JSON.stringify(state, (k, v) => {
      if (v instanceof Date) {
        return v.toISOString();
      }
      return v;
    });
    localStorage.setItem(key, serializedState);
  } catch (err) {
    console.error("Could not save state", err);
  }
};

const clearState = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error("Could not clear state", err);
  }
};

export { loadState, saveState, clearState };
export default { loadState, saveState, clearState };